import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { getPermissionState } from '@app/reducers/auth/permission.helper';
import { Store } from '@ngrx/store';
import { AppState } from '@reducers/interfaces';
import { hasPermission } from '@sb/shared/permission/util';
import { Observable, of as observableOf } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class DowngradeGuard {
  private store = inject<Store<AppState>>(Store);
  private router = inject(Router);

  canActivate(): Observable<boolean> | boolean {
    return this.store.select(getPermissionState).pipe(
      switchMap((permissionState) => {
        const hasDowngradePermission = hasPermission(
          {
            departments: 'any',
            permissions: ['Manage account', 'Edit user permissions', 'Edit contracts'],
          },
          permissionState,
        );

        if (hasDowngradePermission) {
          return observableOf(true);
        } else {
          this.redirectToDashboard();
          return observableOf(false);
        }
      }),
    );
  }

  private redirectToDashboard() {
    this.router.navigate(['/dashboard']);
  }
}
